"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Module = ({
  fill = '#fff',
  ...rest
}) => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32"
}, rest), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  id: "1",
  fill: fill,
  transform: "translate(7.000000, 4.000000)"
}, _react.default.createElement("path", {
  d: "M2.96377005,2 L9.80873608,11.4118283 C10.0637546,11.7624788 10.0637546,12.2375212 9.80873608,12.5881717 L2.96377005,22 L8.49077541,22 L15.7635027,12 L8.49077541,2 L2.96377005,2 Z M7.76350268,12 L0.191263916,1.5881717 C-0.289441042,0.927202381 0.182713212,0 1,0 L9,0 C9.31993659,0 9.62055844,0.15308404 9.80873608,0.411828302 L17.8087361,11.4118283 C18.0637546,11.7624788 18.0637546,12.2375212 17.8087361,12.5881717 L9.80873608,23.5881717 C9.62055844,23.846916 9.31993659,24 9,24 L1,24 C0.182713212,24 -0.289441042,23.0727976 0.191263916,22.4118283 L7.76350268,12 Z"
}))));
var _default = exports.default = Module;